import React, { useEffect, useCallback } from 'react';
import Select from 'react-select';
import TargetingClient from '~/state/Targeting/client';

import useCustomAudiences from './hooks/useCustomAudiences';

const handleValue = (e, { action, ...rest }, setPickedAudiences) => {
  switch (action) {
    case 'select-option': {
      TargetingClient.audiences.add(rest.option);
      break;
    }
    case 'pop-value':
    case 'remove-value': {
      TargetingClient.audiences.remove(rest.removedValue.id);
      break;
    }
    case 'clear': {
      TargetingClient.audiences.clear();
      break;
    }
    default: {
      break;
    }
  }

  setPickedAudiences(e);
};

// z-index to prevent ad type buttons from
// overlaying dropdown
const customAudienceStyling = {
  container: () => ({
    zIndex: 900,
  }),
};

const CustomAudiences = (props) => {
  const {
    accountId,
    accessToken,
  } = props;

  const {
    pickedAudiences,
    setPickedAudiences,
    audiences,
  } = useCustomAudiences(accountId, accessToken);

  // Clear out chosen audiences in the store if the account has been changed
  useEffect(() => TargetingClient.audiences.clear, [audiences]);

  const handleSelect = useCallback(
    (e, data) => handleValue(e, data, setPickedAudiences),
    [setPickedAudiences, handleValue],
  );

  return (
    <div className="link__row">
      {' '}
      <div className="link__input-container">
        <div className="collage__header" style={{ width: '300px' }}>
          <h4>Custom Audiences</h4>
          <p>Choose a custom audience</p>
          <Select
            isMulti
            options={audiences}
            getOptionValue={e => e.id}
            getOptionLabel={e => e.name}
            value={pickedAudiences}
            onChange={handleSelect}
            name="Audiences"
            placeholder="Select audience(s)..."
            styles={customAudienceStyling}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomAudiences;
